import { useReducer, useEffect } from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';
import moment from 'moment';
import { Modals } from '../constants/ScreenNames';

const defaultState = {
  isAir: true,
  isHotel: false,
  isDrive: false,
  isVirtual: false,

  hasDescription: false,
  hasMeeting: false,
  hasSpeaker: false,

  name: '',
  description: '',
  city: '',
  venue: '',
  startDate: '',
  endDate: '',
  virtualLink: null,
  startTime: null,
  endTime: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'setIsAir':
      return {
        ...state,
        isAir: !state.isAir,
      };
    case 'setIsHotel':
      return {
        ...state,
        isHotel: !state.isHotel,
      };
    case 'setIsDrive':
      return {
        ...state,
        isDrive: !state.isDrive,
      };
    case 'setIsVirtual':
      return {
        ...state,
        isVirtual: !state.isVirtual,
      };

    case 'setHasDescription':
      return {
        ...state,
        hasDescription: !state.hasDescription,
      };
    case 'setHasMeeting':
      return {
        ...state,
        hasMeeting: !state.hasMeeting,
      };
    case 'setHasSpeaker':
      return {
        ...state,
        hasSpeaker: !state.hasSpeaker,
      };

    case 'setDates':
      return {
        ...state,
        startDate: action.startDate,
        endDate: action.endDate,
      };
    case 'setImages':
      console.log('set images ', action.value);
      return {
        ...state,
        ...action.value,
      };
    default:
      if (action.type) {
        return {
          ...state,
          [action.type]: action.value,
        };
      } else {
        return state;
      }
  }
};

const getInitialState = (initial) => {
  if (initial) {
    return {
      ...defaultState,
      ...initial,
    };
  }
  return defaultState;
};

const useEventWidget = (initialState) => {
  const navigation = useNavigation();
  const route = useRoute();
  const [state, dispatch] = useReducer(reducer, getInitialState(initialState));
  const isOnlyVirtual = !state.isAir && !state.isHotel && !state.isDrive && state.isVirtual;
  const isOnlyAir = state.isAir && !state.isHotel && !state.isDrive && !state.isVirtual;
  const isDriveOrVirtual = state.isDrive || state.isVirtual;
  const isAirDominant = state.isAir && isDriveOrVirtual;
  const { selectedDates, selectedLocation, selectedTimes, selectedElement } = route?.params || {};
  const extras = {
    isOnlyVirtual,
    isOnlyAir,
    isDriveOrVirtual,
    isAirDominant,
  };

  const openCalendar = () => {
    navigation.navigate(Modals.Calendar, {
      returnScreen: route.name,
      //minDate: moment(new Date()).subtract(331, 'days').format('YYYY-MM-DD'),
      maxDate: moment(new Date()).add(331, 'days').format('YYYY-MM-DD'),
      //pastScrollRange: 10,
      futureScrollRange: 10,
      allowRange: true,
      fromDate: state.date,
    });
  };

  useEffect(() => {
    if (selectedElement && typeof selectedElement.id === 'number') {
      console.log('selected elements ', selectedElement);
      dispatch({
        type: 'platform',
        value: selectedElement.id,
      });
    }
  }, [selectedElement]);

  useEffect(() => {
    if (selectedDates?.startDate) {
      dispatch({
        type: 'setDates',
        startDate: selectedDates?.startDate,
        endDate: selectedDates?.endDate,
      });
    }
  }, [selectedDates]);

  useEffect(() => {
    if (selectedLocation?.inputName === 'setEventCity') {
      dispatch({ type: 'city', value: selectedLocation });
    } else if (selectedLocation?.inputName === 'setEventVenue') {
      dispatch({ type: 'venue', value: selectedLocation });
    }
  }, [selectedLocation]);

  useEffect(() => {
    console.log('selected times ', selectedTimes);
    if (
      selectedTimes &&
      (selectedTimes.inputName === 'startTime' || selectedTimes.inputName === 'endTime')
    ) {
      dispatch({ type: selectedTimes.inputName, value: selectedTimes });
    }
  }, [selectedTimes]);

  const validate = () => {
    // TODO: validate form
  };
  console.log('state ', state);

  return [state, dispatch, openCalendar, validate, extras];
};

export default useEventWidget;
